import actionTypes from '../constants/action-types';

const ownerId = (state = null, action) => {
  if (action.type !== actionTypes.SET_OWNER_ID) {
    return state;
  }

  return action.payload.ownerId;
};

export default ownerId;
